import { TLC_CONSTANTS } from "../../../../js/lib/tlc-constants";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";
import { EventableMixin } from "../../events/EventableMixin";
import { ApplicationData } from "../../ls2pac/ApplicationData";
import { LS2KIDS_CONSTANTS } from "../constants";
import { KidsCategoryManager } from "./categoryManager";
import { KidsSeriesManager } from "./seriesManager";

/**
 * tlc.ls2kids.managers.GoogleAnalyticsManager
 */
export class KidsGoogleAnalyticsManager {
	constructor() { }
	static gtag() {
		window.dataLayer.push(arguments);
	}
	static init() {
		if (window.communityTrackingEnabled) {
			this.gtag('config', window['trackingCode'], {
				'send_page_view': false
			});
		}

		var analytics = ApplicationData.locationConfiguration.getGoogleAnalyticsSettings();
		if (analytics.googleTrackingEnabled && analytics.googleTrackingCode != null && analytics.googleTrackingCode.length > 0) {
			KidsGoogleAnalyticsManager._isCustomerEnabled = true;

			this.gtag('config', analytics.googleTrackingCode, {
				'send_page_view': false
			});
		}

		KidsGoogleAnalyticsManager.events = [
			LS2KIDS_CONSTANTS.Events.onCategoryGridRefresh,
			LS2KIDS_CONSTANTS.Events.onSearch,
			LS2KIDS_CONSTANTS.Events.onSeriesGridRefresh,
			TLC_CONSTANTS.Events.onPagingModelResponse,
			LS2KIDS_CONSTANTS.Events.onShowLoadingMessage,
			LS2KIDS_CONSTANTS.Events.onGridViewPrevPage,
			LS2KIDS_CONSTANTS.Events.onGridViewNextPage,
			LS2PAC_CONSTANTS.Events.onClearSearch,
			LS2KIDS_CONSTANTS.Events.onPromptToHoldResource,
			LS2PAC_CONSTANTS.Events.onGetSpellingSuggestionsResponse,
			LS2KIDS_CONSTANTS.Events.onFocusFullDetailsSection,
			LS2PAC_CONSTANTS.Events.onLoginResponse,
			LS2PAC_CONSTANTS.Events.onRequestResponse,
			LS2PAC_CONSTANTS.Events.onLogoutResponse,
			LS2PAC_CONSTANTS.Events.onTimeout,
			LS2KIDS_CONSTANTS.Events.onStartAutoCycle,
			LS2KIDS_CONSTANTS.Events.onResultsViewPrevPage,
			LS2KIDS_CONSTANTS.Events.onResultsViewNextPage
		];

		// TODO investigate, addEvents was called here but I don't see a method implementation
		// KidsGoogleAnalyticsManager.addEvents();

		KidsGoogleAnalyticsManager.attachEventListeners();
	}
	static attachEventListeners() {
		$("body")
			.on(
				'click',
				"#" + LS2KIDS_CONSTANTS.Ids.footer.exploreCategories,
				KidsGoogleAnalyticsManager._exploreCategories
			)
			.on(
				'click',
				"#" + LS2KIDS_CONSTANTS.Ids.footer.exploreSeries,
				KidsGoogleAnalyticsManager._exploreSeries
			)
			.on(
				'click',
				"#" + LS2KIDS_CONSTANTS.Ids.footer.mainFooter + " .footerBar a",
				KidsGoogleAnalyticsManager._additionalLinks
			)
			.on(
				'click',
				'#' + LS2KIDS_CONSTANTS.Ids.Messaging.main + " .spelling-suggestions a",
				KidsGoogleAnalyticsManager._clickedSpellingSuggestions
			)
			.on(
				'click',
				'#' + LS2KIDS_CONSTANTS.Ids.SearchPage.resultsList + " a",
				KidsGoogleAnalyticsManager._jacketFullDetails
			)
			.on(
				'click',
				'#' + LS2KIDS_CONSTANTS.Ids.FullDetails.detailsContainer + ' a',
				KidsGoogleAnalyticsManager._fullDetailsSubSections
			)
			.on(
				'click',
				'#' + LS2KIDS_CONSTANTS.Ids.footer.mainFooter + ' a.scout',
				KidsGoogleAnalyticsManager._scout
			);
	}
	static gaSendPageView(obj) {
		var trackingObject = $.extend(obj, {
			'send_to': window['trackingCode']
		});

		if (window.communityTrackingEnabled) {
			this.gtag('event', 'page_view', trackingObject);
		}

		if (KidsGoogleAnalyticsManager._isCustomerEnabled) {
			var trackingObject2 = $.extend(obj, {
				'send_to': ApplicationData.locationConfiguration.getGoogleAnalyticsSettings().googleTrackingCode
			});
			this.gtag('event', 'page_view', trackingObject2);
		}
	}
	/**
	 *
	 * @param {*} category Typically the object that was interacted with (e.g. button)
	 * @param {*} action The type of interaction (e.g. click)
	 * @param {*=} label Useful for categorizing events (e.g. nav buttons)
	 * @param {*=} value Values must be non-negative. Useful to pass counts (e.g. 4 times)
	 */
	static gaSendEvent(category, action, label, value) {
		var trackingObject = {
			'event_category': category,
			'event_label': label,
			'value': value
		};

		if (window.communityTrackingEnabled) {
			this.gtag('event', action, $.extend(trackingObject,
				{ 'send_to': window['trackingCode'] }));
		}

		if (KidsGoogleAnalyticsManager._isCustomerEnabled) {
			this.gtag('event', action, $.extend(trackingObject,
				{ 'send_to': ApplicationData.locationConfiguration.getGoogleAnalyticsSettings().googleTrackingCode }));
		}
	}
	static gaSet(dimensionName, convertedName, value) {
		var customDim = {};
		customDim[dimensionName] = convertedName;
		var customObj = {
			'custom_map': customDim
		};
		customObj[convertedName] = value;

		if (window.communityTrackingEnabled) {
			this.gtag('config', window['trackingCode'], customObj);
		}

		if (KidsGoogleAnalyticsManager._isCustomerEnabled) {
			this.gtag('config', ApplicationData.locationConfiguration.getGoogleAnalyticsSettings().googleTrackingCode, customObj);
		}
	}
	static urlChange(url, eventData) {
		KidsGoogleAnalyticsManager.gaSet(LS2KIDS_CONSTANTS.GoogleAnalytics.configDimensionName,
			LS2KIDS_CONSTANTS.GoogleAnalytics.configConvertedName,
			window['config']);

		KidsGoogleAnalyticsManager.gaSendPageView({
			'page_path': url
		});
	}
	static _exploreCategories(event) {
		KidsGoogleAnalyticsManager.gaSendEvent("footer", "click", "explore categories");
	}
	static _exploreSeries(event) {
		KidsGoogleAnalyticsManager.gaSendEvent("footer", "click", "explore series");
	}
	static _additionalLinks(event) {
		var value = $(event.target).attr('href').trim();

		KidsGoogleAnalyticsManager.gaSendEvent("footer", "click", "additional link", value);
	}
	static _scout(event) {
		KidsGoogleAnalyticsManager.gaSendEvent("footer", "click", "scout");
	}
	static _clickedSpellingSuggestions(event) {
		var value = $(event.target).attr('href').trim();
		var searchTerm = value.match("^[^\\?]*\\?searchString=(.*)[&]?$");
		if (searchTerm != null && searchTerm.length > 0) {
			KidsGoogleAnalyticsManager.gaSendEvent("spelling suggestion", "click", "term", searchTerm[1]);
		}
	}
	static _jacketFullDetails(event) {
		var value = $(event.currentTarget).find('.jacketContainer').data('image-alt').trim();

		KidsGoogleAnalyticsManager.gaSendEvent("search", "click", "jacket", value);
	}
	static _fullDetailsSubSections(event) {
		var sectionName = $(event.currentTarget).parent().data('section-name');
		KidsGoogleAnalyticsManager.gaSendEvent("full details", "click", "section", sectionName);
	}
}

KidsGoogleAnalyticsManager._isCustomerEnabled = false;








KidsGoogleAnalyticsManager[ LS2KIDS_CONSTANTS.Events.onSearch ] = function ( event ) {
	if( event.searchString ) {
		KidsGoogleAnalyticsManager.gaSendEvent( "search", "load", "title search", event.searchString );
	} else if( event.id ) {
		var category = KidsCategoryManager.getCategory( event.id );
		KidsGoogleAnalyticsManager.gaSendEvent( "search", "load", "category search", category.name );
	} else if( event.seriesId ) {
		var series = KidsSeriesManager.getSeries( event.seriesId );
		KidsGoogleAnalyticsManager.gaSendEvent( "search", "load", "series search", series.name );
	}
};

KidsGoogleAnalyticsManager[ TLC_CONSTANTS.Events.onPagingModelResponse ] = function ( event ) {
	if( event.data.currentPage === 1 ) {
		KidsGoogleAnalyticsManager.gaSendEvent( "search", "load", "result count", event.totalHits );
		var searchTerm = event.data.searchClientManager.searchTermInfo.value;
		KidsGoogleAnalyticsManager.gaSendEvent( "search", "load", "keyword", searchTerm );
	}
};

KidsGoogleAnalyticsManager[ LS2KIDS_CONSTANTS.Events.onShowLoadingMessage ] = function ( event ) {
	KidsGoogleAnalyticsManager.gaSendEvent( "search", "load", "loading message" );
};

KidsGoogleAnalyticsManager[ LS2KIDS_CONSTANTS.Events.onCategoryGridRefresh ] = function ( event ) {
	var dimensions = event.cols + "x" + event.rows;
	KidsGoogleAnalyticsManager.gaSendEvent( "category", "load", "grid", dimensions );
};

KidsGoogleAnalyticsManager[ LS2KIDS_CONSTANTS.Events.onSeriesGridRefresh ] = function ( event ) {
	var dimensions = event.cols + "x" + event.rows;
	KidsGoogleAnalyticsManager.gaSendEvent( "series", "load", "grid", dimensions );
};

KidsGoogleAnalyticsManager[ LS2KIDS_CONSTANTS.Events.onSearchGridRefresh ] = function ( event ) {
	var dimensions = event.cols + "x" + event.rows;
	KidsGoogleAnalyticsManager.gaSendEvent( "search", "load", "grid", dimensions );
};





KidsGoogleAnalyticsManager[ LS2KIDS_CONSTANTS.Events.onGridViewPrevPage ] = function ( event ) {
	var gridPageName = event.name;

	KidsGoogleAnalyticsManager.gaSendEvent( gridPageName, event.type, "previous page" );
};

KidsGoogleAnalyticsManager[ LS2KIDS_CONSTANTS.Events.onGridViewNextPage ] = function ( event ) {
	var gridPageName = event.name;

	KidsGoogleAnalyticsManager.gaSendEvent( gridPageName, event.type, "next page" );
};

KidsGoogleAnalyticsManager[ LS2KIDS_CONSTANTS.Events.onResultsViewPrevPage ] = function ( event ) {
	KidsGoogleAnalyticsManager.gaSendEvent( "search", event.type, "previous page" );
};

KidsGoogleAnalyticsManager[ LS2KIDS_CONSTANTS.Events.onResultsViewNextPage ] = function ( event ) {
	KidsGoogleAnalyticsManager.gaSendEvent( "search", event.type, "next page" );
};


KidsGoogleAnalyticsManager[ LS2PAC_CONSTANTS.Events.onGetSpellingSuggestionsResponse ] = function ( event ) {
	KidsGoogleAnalyticsManager.gaSendEvent( "spelling suggestion", "load", "misspelling", event.term );
};

// TODO reimpl?
KidsGoogleAnalyticsManager[ LS2PAC_CONSTANTS.Events.onClearSearch ] = function ( event ) {
	if( event.sourceEvent && event.sourceEvent.type == "click" ) {
		KidsGoogleAnalyticsManager.gaSendEvent( "header", "click", "clear search" );
	}
};


KidsGoogleAnalyticsManager[ LS2KIDS_CONSTANTS.Events.onPromptToHoldResource ] = function ( event ) {
	var viewId = $( event.event.currentTarget ).parents( ".activeView" ).attr( 'id' );

	if( viewId == LS2KIDS_CONSTANTS.Ids.FullDetails.fullDetailsContainer ) {
		if( $( event.event.currentTarget ).is( ".hold-resource-button" ) ) {
			KidsGoogleAnalyticsManager.gaSendEvent( "full details", "click", "i want this button" );
		} else {
			KidsGoogleAnalyticsManager.gaSendEvent( "full details", "click", "availability" );
		}
	} else if( viewId == LS2PAC_CONSTANTS.Ids.SearchPage.searchPageView ) {
		KidsGoogleAnalyticsManager.gaSendEvent( "search", "click", "availability" );
	}
};


KidsGoogleAnalyticsManager[ LS2KIDS_CONSTANTS.Events.onFocusFullDetailsSection ] = function ( event ) {
	KidsGoogleAnalyticsManager.gaSendEvent( "full details", "click", "section nav", event.sectionName );
};


KidsGoogleAnalyticsManager[ LS2PAC_CONSTANTS.Events.onLoginResponse ] = function ( event ) {
	if( event.success ) {
		KidsGoogleAnalyticsManager.gaSendEvent( "login", "attempt", "success" );
	} else {
		KidsGoogleAnalyticsManager.gaSendEvent( "login", "attempt", "failed", event.response.error );
	}
};

KidsGoogleAnalyticsManager[ LS2PAC_CONSTANTS.Events.onRequestResponse ] = function ( event ) {
	var token = event.data.placeHoldInfos[0].message;
	if( token == "<SuccessToken>" ) {
		KidsGoogleAnalyticsManager.gaSendEvent( "login", "attempt", "success" );
	} else {
		KidsGoogleAnalyticsManager.gaSendEvent( "login", "attempt", "failed", token );
	}
};

KidsGoogleAnalyticsManager[ LS2PAC_CONSTANTS.Events.onLogoutResponse ] = function ( event ) {
	KidsGoogleAnalyticsManager.gaSendEvent( "logout", "load" );
};

KidsGoogleAnalyticsManager[ LS2PAC_CONSTANTS.Events.onTimeout ] = function ( event ) {
	KidsGoogleAnalyticsManager.gaSendEvent( "timeout", "load" );
};

KidsGoogleAnalyticsManager[ LS2KIDS_CONSTANTS.Events.onStartAutoCycle ] = function ( event ) {
	KidsGoogleAnalyticsManager.gaSendEvent( "passive movement", "load" );
};

EventableMixin.call( KidsGoogleAnalyticsManager.prototype );

